export type RandomPickEntry<T> = [value: T, probability: number]
export type RandomPickEntryList<T> = Array<RandomPickEntry<T>>

function _reduceEntries<T>(acc: number, entry: RandomPickEntry<T>): number {
  return acc + entry[1]
}

export function pickRandomItem<T>(items: RandomPickEntryList<T>): T {
  const totalProbability = items.reduce(_reduceEntries, 0)
  const rnd = Math.random()
  let roll = rnd * totalProbability
  for (let i = 0; i < items.length; i++) {
    const [value, probability] = items[i]
    if (roll <= probability) return value
    roll -= probability
  }
  throw new Error(`[Random#pickRandomItem] unreachable${roll} ${JSON.stringify(items)}`)
}

export function shuffleArray<T>(array: T[]) {
  let currentIndex = array.length

  // While there remain elements to shuffle
  while (currentIndex != 0) {
    // Pick a remaining element
    const randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex--

    // And swap it with the current element.
    ;[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
  }
}
